<div class="container">
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
    <div class="col-md-7">
      <h1>Onboarding</h1>
    </div>
    <div class="col-md-5 col-md-auto d-md-flex justify-content-md-end">
      <a
        href="https://e2l.atlassian.net/servicedesk/customer/portal/8/group/30/create/139"
        target="_blank"
        class="btn btn-primary"
        >Submit Onboarding Request
        <i class="bi bi-box-arrow-up-right ms-2 fs-14"></i
      ></a>
    </div>
  </div>

  <div class="d-flex justify-content-between">
    <nav ngbNav #nav="ngbNav" class="nav-tabs mt-2">
      <ng-container [ngbNavItem]="1">
        <a ngbNavLink class="nav-link"> Topics </a>
        <ng-template ngbNavContent>
          <app-onboarding-topics-page />
        </ng-template>
      </ng-container>
      <ng-container [ngbNavItem]="2">
        <a ngbNavLink class="nav-link">Proforms</a>
        <ng-template ngbNavContent
          ><app-onboarding-proforms-page
        /></ng-template>
      </ng-container>
    </nav>
  </div>
  <div class="card border-0 p-3 mb-3 pb-5">
    <div class="card-body">
      <div [ngbNavOutlet]="nav" id="onboarding" class="tab-content p-2"></div>
    </div>
  </div>
</div>
